import { createSelector } from "@reduxjs/toolkit";
import React from "react";
import { useSelector } from "react-redux";
import { Button, Segment } from "semantic-ui-react";
const styles = {
  padding: "0",
};

const selectFundValues = createSelector(
  [
    (state) => state.annuity,
    (state) => state.annuity_section_a,
    (state) => state.auth,
  ],
  (annuity, sectionA, { token }) => {
    return {
      id: annuity.policy,
      fname: sectionA.insfname.value,
      lname: sectionA.inssurname.value,
      token,
    };
  }
);

const RiskSelector = ({ onBeforeNavigate, disabled }) => {
  const { id, fname, lname, token } = useSelector(selectFundValues);
  const handleClick = async (e) => {
    e.stopPropagation();

    // Run the parent's save logic in the background before navigating.
    // We await so the save completes before the page unloads, but we
    // never block navigation on a save failure - the user explicitly
    // asked to go to the Risk Selector.
    if (typeof onBeforeNavigate === "function") {
      try {
        await onBeforeNavigate();
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Background save before Risk Selector failed:", err);
      }
    }

    let url = process.env.REACT_APP_RISK_SELECTOR_URL;
    let return_url = process.env.REACT_APP_RISK_SELECTOR_RETURN_URL;

    window.location.href = `${url}/?id=${id}&fname=${fname}&lname=${lname}&return_url=${return_url}&csrf_token=${token}`;
  };
  return (
    <Segment basic clearing style={styles}>
      <Button
        onClick={handleClick}
        type="button"
        floated="right"
        disabled={disabled}
      >
        Risk Selector
      </Button>
      <span
        style={{
          float: "right",
          lineHeight: "36px",
          marginRight: "10px",
          color: "rgba(0, 0, 0, 0.6)",
          fontStyle: "italic",
        }}
      >
        Click Risk Selector to determine Fund Allocation
      </span>
    </Segment>
  );
};

export default RiskSelector;
